import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import {makeStyles} from "@material-ui/core/styles";
import {lighten} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: 50,
    },
    buttonNext: {
        padding: theme.spacing(1, 4),
        fontWeight: 700,
        borderRadius: 4,
        color: theme.palette.getContrastText(theme.customColors.green),
        backgroundColor: theme.customColors.green,
        '&:hover': {
            backgroundColor: lighten(theme.customColors.green, '0.2'),
        },
    },
    buttonPrev: {
        padding: theme.spacing(1, 4),
        fontWeight: 700,
        marginRight: theme.spacing(1),
        borderRadius: 4,
        color: theme.palette.getContrastText(theme.customColors.red),
        backgroundColor: theme.customColors.red,
        '&:hover': {
            backgroundColor: lighten(theme.customColors.red, '0.2'),
        },
    },
}));

export default function StepNavigator({onNext, disabled, onPrev}) {
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <Button onClick={onPrev} variant="contained" disabled={disabled} className={classes.buttonPrev}>Back</Button>
            <Button onClick={onNext} variant="contained" disabled={disabled} className={classes.buttonNext} >Next</Button>
        </Box>
    )
}
